export default "__VITE_ASSET__7f18464e__"